import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import { apiJalles } from "../services/api";
import { toast } from "react-toastify";

export const MotobombaContext = createContext({});

export const MotobombaProvider = () => {
  const token = sessionStorage.getItem("connectionsToken");
  const [motobombaSalve, setMotobombaSalve] = useState([]);
  const [modalAlertaMotobomba, setModalAlertaMotobomba] = useState(false);
  const [alertasMotoBombas, setAlertasMotoBombas] = useState([]);
  const [modalConfimetionMotobomba, setModalConfimationMotobomba] =
    useState(false);
  const [funtionControleSave, setFuntionConoleSave] = useState([]);
  const [acleracaoList, setAceleracaoListe] = useState({});
  const [loading, setLoading] = useState(false);

  const headerApi = useMemo(
    () => ({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
    [token]
  );

  const listMotoBomba = useCallback(async () => {
    try {
      const response = await apiJalles.get("motobombasjalles/", headerApi);
      setMotobombaSalve(response.data);
    } catch (error) {
      toast.error("Não foi possível carregar as motobombas.");
    }
  }, [headerApi]);

  const alertaListMotobomba = useCallback(async () => {
    try {
      const response = await apiJalles.get("alertasmotobomba/", headerApi);
      setAlertasMotoBombas(response.data);
    } catch (error) {
      toast.error("Não foi possível carregar os alertas das motobombas.");
    }
  }, [headerApi]);

  const motoBombaUpdate = async (data, id, user) => {
    try {
      setLoading(true);
      const update = await apiJalles.patch(
        `motobombasjalles/${id}/`,
        data,
        headerApi
      );
      setMotobombaSalve((prevList) => {
        return prevList.map((item) =>
          item.id === id ? { ...item, ...update.data } : item
        );
      });
      toast.success("Comando Feito com sucesso", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } catch (error) {
      toast.warn("Não foi possível enviar o comando para a motobomba.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } finally {
      setModalConfimationMotobomba(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    alertaListMotobomba();
  }, [alertaListMotobomba]);
  return (
    <MotobombaContext.Provider
      value={{
        motobombaSalve,
        modalAlertaMotobomba,
        setModalAlertaMotobomba,
        alertasMotoBombas,
        modalConfimetionMotobomba,
        setModalConfimationMotobomba,
        funtionControleSave,
        setFuntionConoleSave,
        motoBombaUpdate,
        acleracaoList,
        setAceleracaoListe,
        listMotoBomba,
        loading,
      }}
    >
      <Outlet />
    </MotobombaContext.Provider>
  );
};
